var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83249 11.7693V13.2847H15.1819C15.2687 13.2847 15.3437 13.2553 15.4069 13.1933C15.4687 13.1333 15.5 13.058 15.5 12.9647V2.04133C15.5006 1.95133 15.4725 1.87133 15.4069 1.806C15.3519 1.73933 15.2762 1.70733 15.1831 1.70733H9.83187V3.41933H14.1944V4.07533H9.83187V4.93667H14.1944V5.62533H9.83187V6.47H14.1944V7.15933H9.83187V8.01267H14.1944V8.694H9.83187V9.54533H14.1925V10.2347H9.82874V11.0793H14.1962V11.7693H9.83249ZM9.03187 0L0.5 1.60133V13.4407L9.03187 15V0ZM6.52812 10.2693L5.42187 10.2L5.0375 8.11533C4.81312 6.90333 4.69125 6.19733 4.65312 5.996H4.625C4.59687 6.18467 4.46562 6.87533 4.24062 8.06333L3.85625 10.0893L2.835 10.02L1.85062 4.816L2.76937 4.76467L3.37875 8.89067H3.38812C3.4225 8.69067 3.55312 7.978 3.7875 6.75467L4.18875 4.65333L5.19125 4.6L5.59062 6.754C5.81562 8.02267 5.94125 8.76467 5.975 8.97667H5.99062L6.67562 4.49733L7.74375 4.428V4.42733H7.76562L6.52812 10.2693Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.8a60edd44538f43f9ac98820069ecba5.svg";
export { ForwardRef as ReactComponent };